import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementEsLocale from 'element-ui/lib/locale/lang/es'// element-ui lang
import elementFrLocale from 'element-ui/lib/locale/lang/fr'// element-ui lang
import elementArLocale from 'element-ui/lib/locale/lang/ar'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'
import esLocale from './es'
import frLocale from './fr'
import arLocale from './ar'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  es: {
    ...esLocale,
    ...elementEsLocale
  },
  fr: {
    ...frLocale,
    ...elementFrLocale
  },
  ar: {
    ...arLocale,
    ...elementArLocale
  }
}
if (!Cookies.get('language')) {
  switch (navigator.language) {
    case 'ar':
      Cookies.set('language', 'ar')
      break
    case 'fr':
      Cookies.set('language', 'fr')
      break
    case 'es':
      Cookies.set('language', 'es')
      break
    case 'zh-CN':
      Cookies.set('language', 'zh')
      break
    default:
      Cookies.set('language', 'en')
      break
  }
}
const languageList = [
  {
    language: 'zh',
    name: '中文'
  }, {
    language: 'en',
    name: 'English'
  }, {
    language: 'es',
    name: 'Español'
  }, {
    language: 'fr',
    name: 'Français'
  }, {
    language: 'ar',
    name: 'بالعربية'
  }
]
// this.$t()是vue-i18n的数据渲染模板语法，自带的，在main的js中全局化
const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: Cookies.get('language') || 'zh',
  // set locale messages
  messages
})

export { i18n, languageList }



// WEBPACK FOOTER //
// ./src/lang/index.js